/* Skins: paletas de color de acento alternativas sobre el mismo fondo oscuro. Cada una define
   --accent/--accent-hover/--accent-soft (y las variables de Framework7 a juego) en
   html[data-skin="ID"] dentro de tokens.css; "default" es el rojo original y no necesita bloque
   propio porque coincide con :root. */

export const SKINS = [
    { id: 'default', accent: '#e50914' },
    { id: 'ocean', accent: '#2f80ed' },
    { id: 'emerald', accent: '#1db954' },
    { id: 'amethyst', accent: '#8e44ec' },
    { id: 'amber', accent: '#d97706' },
    { id: 'rose', accent: '#ec4899' }
];

export function skinById(id) {
    return SKINS.find((s) => s.id === id) || SKINS[0];
}
